import { render, staticRenderFns } from "./AddPlayerByTeam.vue?vue&type=template&id=5ed71c04&scoped=true&"
import script from "./AddPlayerByTeam.vue?vue&type=script&lang=js&"
export * from "./AddPlayerByTeam.vue?vue&type=script&lang=js&"
import style0 from "./AddPlayerByTeam.vue?vue&type=style&index=0&id=5ed71c04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed71c04",
  null
  
)

export default component.exports